import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LinkFacebookButton from '../../../../../../../components/shared/facebook/LinkFacebookButton';
import { useOnboardingContext } from '../../../../../state/OnboardingContext';
import { CLEAR_ALERT } from '../../../../../state/Onboarding.actions';
import { t } from '../../../../../shared/onboarding-utils';

const OnboardingLinkFacebook = ({ requestFriends, authorizationStatus }) => {
  const { dispatch, track } = useOnboardingContext();

  useEffect(() => {
    track({
      action: 'screen_enter',
      element: 'connect_fb',
      properties: {
        authorization_status: authorizationStatus
      }
    });
  }, [authorizationStatus, track]);

  const handleClick = () => {
    dispatch({ type: CLEAR_ALERT });
    track({
      action: 'click',
      element: 'connect_fb'
    });
    requestFriends();
  };

  return (
    <LinkFacebookButton onClick={handleClick} fullWidth={true}>
      {t('facebook.button')}
    </LinkFacebookButton>
  );
};

OnboardingLinkFacebook.propTypes = {
  requestFriends: PropTypes.func.isRequired,
  authorizationStatus: PropTypes.string.isRequired
};

export default OnboardingLinkFacebook;
